import {materialConnection} from "#material/nodes/base/connection/shorthand"
import {OutputMaterial} from "#material/nodes/base/output/output-material"
import {Tangent} from "#material/nodes/input/tangent/tangent"
import {UvMap} from "#material/nodes/input/uv-map/uv-map"
import {BsdfPrincipled} from "#material/nodes/shader/bsdf-principled/bsdf-principled"
import {TextureSet} from "#material/nodes/texture/texture-set/texture-set"

export const graphForTextureSet = (textureSetRevisionId?: string) => {
    const textureSetNode = new TextureSet({
        parameters: {
            inputs: {
                uv: materialConnection(
                    new UvMap({
                        parameters: {
                            inputs: {},
                            settings: {
                                uv: {
                                    x: 0,
                                    y: 0,
                                    z: 0,
                                },
                                fromInstancer: false,
                                uvMap: "UVMap",
                                uvMapIndex: 0,
                            },
                            ui: {
                                position: {
                                    x: -116.117,
                                    y: 417.111,
                                },
                            },
                        },
                    }),
                    "uv",
                ),
            },
            settings: {
                textureSetRevisionId,
                transmissionMin: 0.2,
                transmissionMax: 0.9,
            },
            ui: {
                position: {
                    x: 118.4,
                    y: 68.95,
                },
            },
        },
    })
    return new OutputMaterial({
        parameters: {
            inputs: {
                surface: materialConnection(
                    new BsdfPrincipled({
                        parameters: {
                            inputs: {
                                tangent: materialConnection(
                                    new Tangent({
                                        parameters: {
                                            inputs: {},
                                            settings: {
                                                tangent: {
                                                    x: 0,
                                                    y: 0,
                                                    z: 0,
                                                },
                                                axis: "Z",
                                                directionType: "UV_MAP",
                                                uvMap: "UVMap",
                                                uvMapIndex: 0,
                                            },
                                            ui: {
                                                position: {
                                                    x: 516.0419999999999,
                                                    y: 251.909,
                                                },
                                            },
                                        },
                                    }),
                                    "tangent",
                                ),
                                normal: materialConnection(textureSetNode, "normal"),
                                alpha: materialConnection(textureSetNode, "alpha"),
                                anisotropicRotation: materialConnection(textureSetNode, "anisotropicRotation"),
                                anisotropic: materialConnection(textureSetNode, "anisotropic"),
                                roughness: materialConnection(textureSetNode, "roughness"),
                                specular: materialConnection(textureSetNode, "specular"),
                                metallic: materialConnection(textureSetNode, "metallic"),
                                baseColor: materialConnection(textureSetNode, "baseColor"),
                            },
                            settings: {
                                baseColor: {
                                    r: 0.08253519982099533,
                                    g: 0.291306734085083,
                                    b: 0.8000000715255737,
                                    a: 1,
                                },
                                subsurface: 0,
                                subsurfaceRadius: {
                                    x: 1,
                                    y: 0.2000000029802322,
                                    z: 0.1000000014901161,
                                },
                                metallic: 0,
                                specular: 0.2681818008422852,
                                specularTint: 0,
                                roughness: 0.1636363714933395,
                                anisotropic: 0,
                                anisotropicRotation: 0.2777000069618225,
                                sheen: 0,
                                sheenTint: 0,
                                clearcoat: 0,
                                clearcoatRoughness: 0.02999999932944775,
                                ior: 1.450000047683716,
                                transmission: 0,
                                emission: {
                                    r: 0,
                                    g: 0,
                                    b: 0,
                                    a: 1,
                                },
                                alpha: 1,
                                normal: {
                                    x: 0,
                                    y: 0,
                                    z: 0,
                                },
                                clearcoatNormal: {
                                    x: 0,
                                    y: 0,
                                    z: 0,
                                },
                                tangent: {
                                    x: 0,
                                    y: 0,
                                    z: 0,
                                },
                                distribution: "GGX",
                                subsurfaceMethod: "BURLEY",
                            },
                            ui: {
                                position: {
                                    x: 744.4129999999999,
                                    y: -23.8364,
                                },
                            },
                        },
                    }),
                    "bsdf",
                ),
                displacement: materialConnection(textureSetNode, "displacement"),
            },
            settings: {
                displacement: {
                    x: 0,
                    y: 0,
                    z: 0,
                },
                isActiveOutput: true,
                target: "ALL",
                displacementEnabled: false,
            },
            ui: {
                position: {
                    x: 1108.392,
                    y: 444.216,
                },
            },
        },
    })
}
